import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  /** on start */
  connect() {
    const messages = document.getElementById("messages");
    this.scrollDown();
    this.observer = new MutationObserver(mutations => {
      for (let mutation of mutations) {
        for (let node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          if (node.hasAttribute("broadcasted")) {
            this.scrollDown();
          }
        }
      }
    });
    this.observer.observe(messages, { childList: true });
  }

  /** on end  */
  disconnect() {
    this.observer.disconnect();
  }

  scrollDown() {
    messages.scrollTop = messages.scrollHeight;
  }

}